import { OnInit } from "@angular/core";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { WidgetsService, SearchCache } from "src/common";
import { TranslationManager } from "src/common/translation";

@Component({
  selector: 'undelivered-supplier-offers-widget',
  templateUrl: './undelivered-supplier-offers-widget.component.html'
})
export class UndeliveredSupplierOffersWidgetComponent implements OnInit {

  value: number;
  loading: boolean = false;
  translationManager = TranslationManager;
  filteredIds: number[];

  constructor(private widgetsService: WidgetsService, private router: Router) { }

  ngOnInit(): void {
    this.loading = true;
    this.widgetsService.getUndeliveredSupplierOffers().then((result: number[]) => {
      this.filteredIds = result;
      this.value = result.length;
    }).finally(() => {
      this.loading = false;
    });
  }

  onClick() {
    if (this.value > 0){
      SearchCache.clear();
      SearchCache.Filters = [];
      this.filteredIds.forEach(id => {
        SearchCache.Filters.push({ entity: "RequestId", value: id.toString().trim(), action: "equals" })
      });
      SearchCache.Filters.push({ entity: "RequestRoundStatusUniqueIdentifier", value: 'Initiated', action: "equals" });

      this.router.navigate(['/supplier-rounds']);
    }
  }
}
